import React, { useEffect, Children } from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { PinIcon, ChevronRightIcon } from 'lucide-react';
interface BlogsPageProps {
  onNavigate: (page: string) => void;
}
export function BlogsPage({
  onNavigate
}: BlogsPageProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const blogs = [{
    title: 'Online Casino Cheating',
    date: 'January 6, 2025',
    excerpt: 'Online Casino Cheating Special conditions may apply regarding VIP clients, online casino cheating check out our article ...'
  }, {
    title: 'Online Casino Cheating',
    date: 'January 6, 2025',
    excerpt: 'Online Casino Cheating Special conditions may apply regarding VIP clients, online casino cheating check out our article ...'
  }, {
    title: 'Online Casino Cheating',
    date: 'January 6, 2025',
    excerpt: 'Online Casino Cheating Special conditions may apply regarding VIP clients, online casino cheating check out our article ...'
  }, {
    title: 'Play Online 13 Card Rummy Game For Cash',
    date: 'January 6, 2025',
    excerpt: 'Play Online 13 Card Rummy Game For Cash Play online 13 card rummy game for cash if ...'
  }, {
    title: 'Play Online 13 Card Rummy Game For Cash',
    date: 'January 6, 2025',
    excerpt: 'Play Online 13 Card Rummy Game For Cash Play online 13 card rummy game for cash if ...'
  }, {
    title: 'Online Casino No Deposit Bonus Free Money',
    date: 'January 6, 2025',
    excerpt: 'Online Casino No Deposit Bonus Free Money Nevertheless Zhao Cai Jin Bao brings some nice features with ...'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <main className="flex-grow w-full bg-[#f0f2f5]" data-id="element-629">
      <PageHeader title="Blogs" breadcrumb="Blogs" onNavigateHome={() => onNavigate('home')} data-id="element-630" />

      <section className="py-20" data-id="element-631">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-632">
          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-633">
            {blogs.map((blog, index) => <motion.article key={index} variants={cardVariants} className="flex flex-col bg-white rounded-2xl shadow-sm border border-gray-100/80 overflow-hidden group hover:shadow-lg transition-shadow duration-300" data-id="element-634">
                <div className="p-7 flex flex-col flex-grow" data-id="element-635">
                  <div className="flex items-start gap-3 mb-4" data-id="element-636">
                    <div className="bg-[#f05a28] p-2 rounded-lg shrink-0 mt-0.5" data-id="element-637">
                      <PinIcon className="w-4 h-4 text-white" data-id="element-638" />
                    </div>
                    <h3 className="text-lg font-bold text-brand-navy leading-snug" data-id="element-639">
                      {blog.title}
                    </h3>
                  </div>

                  <div className="flex items-center text-[13px] text-gray-400 mb-5 pl-0.5" data-id="element-640">
                    <span data-id="element-641">{blog.date}</span>
                    <span className="mx-2" data-id="element-642">·</span>
                    <span data-id="element-643">Posted by: Admin</span>
                  </div>

                  <p className="text-gray-500 text-sm leading-relaxed mb-6 flex-grow" data-id="element-644">
                    {blog.excerpt}
                  </p>

                  <button onClick={() => onNavigate(`blog-post-${index}`)} className="inline-flex items-center text-[#f05a28] text-sm font-semibold group-hover:gap-2 gap-1 transition-all mt-auto cursor-pointer" data-id="element-645">
                    Read More
                    <ChevronRightIcon className="w-4 h-4 stroke-[2.5] group-hover:translate-x-0.5 transition-transform" data-id="element-646" />
                  </button>
                </div>
              </motion.article>)}
          </motion.div>
        </div>
      </section>
    </main>;
}